import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-generic-aha-gold-prompt',
  templateUrl: './generic-aha-gold-prompt.component.html',
  styleUrls: ['./generic-aha-gold-prompt.component.scss'],
})
export class GenericAhaGoldPromptComponent {
  label = 'go_home';
  isBackPressed = false;
  redirectFrom: string;
  selectedIndex: number;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    if (data?.buttonText) {
      this.label = data.buttonText;
    }
    if (data?.redirectFrom) {
      this.redirectFrom = data.redirectFrom;
    }
    if (data?.selectedIndex !== undefined && data?.selectedIndex !== null) {
      this.selectedIndex = data.selectedIndex;
    }
  }

  disabled(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.isUp() || event.isDown()) {
      this.disabled(event);
    }
  }
}
